import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import {
  FinancialConsultInstallmentSituationType,
  FinancialConsultPayable,
} from '@/core/domain/financial/Consultation/consultation.types';
import { Col, Input, Modal, ModalProps, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';

interface BillToPayMigrationConsultDetailsModalProps
  extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  installmentData?: FinancialConsultPayable;
}

export default function BillToPayMigrationConsultDetailsModal(
  props: BillToPayMigrationConsultDetailsModalProps,
) {
  const installmentData = props.installmentData;
  const installmentIdentifier = `${installmentData?.code}-${installmentData?.installmentNumber}`;

  const situation = installmentData?.situation
    ? FinancialConsultInstallmentSituationType[installmentData.situation]
    : null;

  return (
    <Modal
      {...props}
      width={800}
      title={`Parcela ${installmentIdentifier}`}
      okButtonProps={{ style: { display: 'none' } }}
    >
      <Row gutter={[12, 12]}>
        {situation && (
          <Col span={24}>
            <StatusTag
              label={situation.label}
              color={situation.color}
              size="lg"
            />
          </Col>
        )}

        <Col span={12}>
          <FloatingFormItem label="Usuário">
            <Input disabled value={installmentData?.user} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Empresa">
            <Input disabled value={installmentData?.companyName} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label="Descrição">
            <Input disabled value={installmentData?.description} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Credor">
            <Input disabled value={installmentData?.creditor} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Tipo de documento">
            <Input disabled value={installmentData?.documentType} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Plano de contas">
            <Input disabled value={installmentData?.planAccount} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Centro de custo">
            <Input disabled value={installmentData?.costCenter} />
          </FloatingFormItem>
        </Col>

        <Col span={8}>
          <FloatingFormItem label="Dt. de emissão">
            <InputDate disabled value={moment(installmentData?.emissionDate)} />
          </FloatingFormItem>
        </Col>

        <Col span={8}>
          <FloatingFormItem label="Dt. de vencimento">
            <InputDate disabled value={moment(installmentData?.dueDate)} />
          </FloatingFormItem>
        </Col>

        <Col span={8}>
          <FloatingFormItem label="Dt. de pagamento">
            <InputDate
              disabled
              value={
                installmentData?.payDate
                  ? moment(installmentData?.payDate)
                  : undefined
              }
            />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Nº documento">
            <Input disabled value={installmentData?.documentNumber} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Conta bancária">
            <Input disabled value={installmentData?.bankAccount} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Valor">
            <InputDecimal disabled value={installmentData?.installmentValue} />
          </FloatingFormItem>
        </Col>

        <Col span={12}>
          <FloatingFormItem label="Desc./Acrec.">
            <InputDecimal disabled value={installmentData?.discountIncrease} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label="Observação">
            <TextArea disabled value={installmentData?.observation} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Modal>
  );
}
